import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = { class: "font-semibold text-xs tracking-wider text-gray-1 uppercase" }
const _hoisted_5 = { class: "text-xs text-gray-2 opacity-70" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "w-10 h-10 rounded-full bg-gray-base",
      src: _ctx.avatarUrl,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.creditorName), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.creditorTaxId), 1)
    ])
  ]))
}